export const DOCUMENT_TYPE_DOMAINS = ['FOOD_SAFETY', 'WORKPLACE_SAFETY', 'LEGAL'] as const;
export type DocumentTypeDomain = (typeof DOCUMENT_TYPE_DOMAINS)[number];

export const DOCUMENT_TYPE_RECURRENCE_ANCHORS = [
  'FROM_ISSUE_DATE',
  'FROM_PREVIOUS_EXPIRY',
  'FROM_COMPLETION',
] as const;
export type DocumentTypeRecurrenceAnchor = (typeof DOCUMENT_TYPE_RECURRENCE_ANCHORS)[number];

export const LEGAL_REF_ALLOWED_HOSTS: readonly string[] = [
  'eur-lex.europa.eu',
  'www.normattiva.it',
  'www.gazzettaufficiale.it',
];

/** Stesso tetto di `warningDays` della riga (spec §6: `@ArrayMaxSize(4)`). */
export const MAX_CATALOG_WARNING_DAYS = 4;

export function isAllowedLegalRefUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && LEGAL_REF_ALLOWED_HOSTS.includes(url.hostname);
  } catch {
    return false;
  }
}

/** "Altro" si riconosce dal `catalogKey`: lo slug è `OTHER` nei DB seminati e `altro` nei cataloghi nuovi. */
export const OTHER_DOCUMENT_TYPE_CATALOG_KEY = 'altro';

export function isOtherDocumentType(documentType: { catalogKey: string | null }): boolean {
  return documentType.catalogKey === OTHER_DOCUMENT_TYPE_CATALOG_KEY;
}
